import axios from 'axios';
import { apiTimeout } from '../error';

const { REACT_APP_API_URL } = process.env;

// Public offers (coupons with a website placement). One request per couple of
// minutes feeds the popup, the deals section and the property list banner.
const TTL_MS = 2 * 60 * 1000;
let cache = null; // { at, promise }

/** Every live public offer: [{ code, title, placements, rules, terms, propertyIds, cities, theme, … }] */
export function fetchPublicOffers({ fresh = false } = {}) {
  if (!fresh && cache && Date.now() - cache.at < TTL_MS) return cache.promise;
  const promise = apiTimeout(axios.get(`${REACT_APP_API_URL}/coupon/public`, { params: { placement: 'all' } }))
    .then((res) => (Array.isArray(res.data?.data) ? res.data.data : []))
    .catch(() => {
      cache = null;
      return [];
    });
  cache = { at: Date.now(), promise };
  return promise;
}

/** Offers for one spot, in the order the admin set (sortOrder). */
export async function fetchOffersFor(placement, limit) {
  const all = await fetchPublicOffers();
  const list = all.filter((o) => (o.placements || []).includes(placement));
  return limit ? list.slice(0, limit) : list;
}

/** One offer by code or slug, for /offers/:code. Throws when it isn't live. */
export async function fetchOffer(codeOrSlug) {
  const res = await apiTimeout(axios.get(`${REACT_APP_API_URL}/coupon/public/${encodeURIComponent(codeOrSlug)}`));
  return res.data?.data;
}

/** Public property list (same endpoint as /properties), unfiltered. */
export async function fetchPublicProperties() {
  const res = await apiTimeout(axios.get(`${REACT_APP_API_URL}/property/consumer`));
  const raw = res.data?.data;
  return Array.isArray(raw) ? raw : Array.isArray(raw?.rows) ? raw.rows : [];
}
